import { createSlice } from '@reduxjs/toolkit';
import { db } from '../lib/database';

const initialState = {
    pendingCount: 0,
    syncInProgress: false,
    lastSyncTime: null,
    error: null,
    selectedSurveys: [],
    syncProgress: { current: 0, total: 0, currentItem: '' },
    syncingFormIds: []
};

const syncSlice = createSlice({
  name: 'sync',
  initialState,
  reducers: {
    setSyncInProgress: (state, action) => {
      state.syncInProgress = action.payload;
    },
    updatePendingCount: (state, action) => {
      state.pendingCount = action.payload;
    },
    clearSyncError: (state) => {
      state.error = null;
    },
    setSyncError: (state, action) => {
      state.error = action.payload;
    },
    setLastSyncTime: (state, action) => {
      state.lastSyncTime = action.payload;
      if (action.payload) {
        db.settings.put({ key: 'lastSyncTime', value: action.payload });
      }
    },
    setSelectedSurveys: (state, action) => {
      state.selectedSurveys = action.payload;
    },
    toggleSurveySelection: (state, action) => {
      const surveyId = action.payload;
      const index = state.selectedSurveys.indexOf(surveyId);
      if (index > -1) {
        state.selectedSurveys.splice(index, 1);
      } else {
        state.selectedSurveys.push(surveyId);
      }
    },
    clearSelectedSurveys: (state) => {
      state.selectedSurveys = [];
    },
    setSyncProgress: (state, action) => {
      state.syncProgress = action.payload;
    },
    addSyncingFormId: (state, action) => {
      if (!state.syncingFormIds.includes(action.payload)) {
        state.syncingFormIds.push(action.payload);
      }
    },
    removeSyncingFormId: (state, action) => {
      state.syncingFormIds = state.syncingFormIds.filter(id => id !== action.payload);
    },
    clearSyncingFormIds: (state) => {
      state.syncingFormIds = [];
    },
    resetSync: () => initialState
  }
});

export const {
  setSyncInProgress,
  updatePendingCount,
  clearSyncError,
  setSyncError,
  setLastSyncTime,
  setSelectedSurveys,
  toggleSurveySelection,
  clearSelectedSurveys,
  setSyncProgress,
  addSyncingFormId,
  removeSyncingFormId,
  clearSyncingFormIds,
  resetSync
} = syncSlice.actions;

export default syncSlice.reducer;